module.exports = __webpack_public_path__ + "static/media/qr-stores.82732d8e.png";